import React from "react";
import ReactDom from "react-dom";
// Import CSS
import "./index.css";

// Import JS
import { books } from "./books";
import Book from "./Book";

// Create Variable Objects

function BookList() {
  return (
    <div>
      <Heading />
      <section className='booklist'>
        {books.map((book) => {
          const { img, title, author } = book;
          return <Book key={book.id} {...book}></Book>;
        })}
      </section>

      <Footer />
    </div>
  );
}

const Heading = () => {
  return (
    <header>
      <h1>Project 1</h1>
      <h2>"Amazon Best Seller" Page MockUp</h2>
    </header>
  );
};

const Footer = () => {
  return (
    <footer>
      <p>Lucky Osunbiyi © 2021. Made with React.js</p>
    </footer>
  );
};

ReactDom.render(<BookList />, document.getElementById("root"));
